// import { getTimeStampParameter } from 'utils/feedUtils';
import {
  getTopicFeedUrl,
  getTopicFeedUrlReduxXHR,
} from 'helpers/feeds/generalHelpers';
import { TOI_DEV_DOMAIN, TOI_LIVE_DOMAIN } from 'constants/index.js';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';
import {
  ContentLoadCount,
  topStoriesMsid,
} from './components/Common/constants';

const reducerName = 'topic';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_INITIAL_TOPIC_DATA = createActionName(
  'RECEIVE_INITIAL_TOPIC_DATA',
);
export const RECEIVE_TOPIC_TAB_CONTENT_DATA = createActionName(
  'RECEIVE_TOPIC_TAB_CONTENT_DATA',
);
// export const RECEIVE_ABOUT_DATA = createActionName('RECEIVE_ABOUT_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const RECEIVE_TOPIC_TAB_DATA = createActionName(
  'RECEIVE_TOPIC_TAB_DATA',
);
export const RECEIVE_TOPIC_PHOTO_DATA = createActionName(
  'RECEIVE_TOPIC_PHOTO_DATA',
);
export const RECEIVE_TOPIC_PHOTOSTORYGALLERY_DATA = createActionName(
  'RECEIVE_TOPIC_PHOTOSTORYGALLERY_DATA',
);
export const RECEIVE_TOPIC_NEWS_DATA = createActionName(
  'RECEIVE_TOPIC_NEWS_DATA',
);
export const RECEIVE_PUB_LIST_DATA = createActionName('RECEIVE_PUB_LIST_DATA');
export const RECEIVE_SEO_KEYWORDS = createActionName('RECEIVE_SEO_KEYWORDS');
export const RECEIVE_TOPIC_VIDEO_DATA = createActionName(
  'RECEIVE_TOPIC_VIDEO_DATA',
);
export const RECEIVE_TOPIC_FILTER_DATA = createActionName(
  'RECEIVE_TOPIC_FILTER_DATA',
);

export const RECEIVE_KEYWORDS_FACET_DATA = createActionName(
  'RECEIVE_KEYWORDS_FACET_DATA',
);

export const RECEIVE_TOP_STORIES = createActionName('RECEIVE_TOP_STORIES');

export const RECEIVE_SEARCH_REDIRECTION_DATA = createActionName(
  'RECEIVE_SEARCH_REDIRECTION_DATA',
);

// export const RECEIVE_TOPIC_DATA = createActionName(
//   'RECEIVE_INITIAL_TOPIC_DATA',
// );
// action creators
function receiveTopicData(data) {
  return {
    type: RECEIVE_INITIAL_TOPIC_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveTopicTabContent(data) {
  return {
    type: RECEIVE_TOPIC_TAB_CONTENT_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveTopicTabData(data) {
  return {
    type: RECEIVE_TOPIC_TAB_DATA,
    payload: {
      ...data,
    },
  };
}
function receiveTopicNewsData(data) {
  return {
    type: RECEIVE_TOPIC_NEWS_DATA,
    payload: {
      ...data,
    },
  };
}
function receiveTopicPhotoData(data) {
  return {
    type: RECEIVE_TOPIC_PHOTO_DATA,
    payload: {
      ...data,
    },
  };
}
function receiveTopicPhotostoryGalleryData(data, params) {
  return {
    type: RECEIVE_TOPIC_PHOTOSTORYGALLERY_DATA,
    payload: {
      ...data,
    },
    params,
  };
}
function receiveTopicVideoData(data) {
  return {
    type: RECEIVE_TOPIC_VIDEO_DATA,
    payload: {
      ...data,
    },
  };
}

// function receiveTopicAboutData(data) {
//   return {
//     type: RECEIVE_ABOUT_DATA,
//     payload: {
//       ...data,
//     },
//   };
// }

function receivePubListData(data) {
  return {
    type: RECEIVE_PUB_LIST_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveSeoKeywords(data) {
  return {
    type: RECEIVE_SEO_KEYWORDS,
    payload: {
      ...data,
    },
  };
}

function receiveTopicFilterData(data) {
  return {
    type: RECEIVE_TOPIC_FILTER_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveKeywordsFacetData(data) {
  return {
    type: RECEIVE_KEYWORDS_FACET_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveTopStoriesData(data) {
  return {
    type: RECEIVE_TOP_STORIES,
    payload: {
      ...data,
    },
  };
}

function receiveSearchRedirectionData(data) {
  return {
    type: RECEIVE_SEARCH_REDIRECTION_DATA,
    payload: {
      ...data,
    },
  };
}

function handleTopicDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function fetchTopStoriesData() {
  const domain = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;
  const url = `${domain}/topic_topstoiry_feed_news_list.cms?msid=${topStoriesMsid}&tag=articlelistroot&perpage=10&feedtype=sjson&reqfrm=topic`;
  // #todo remove while pushing
  // console.log('fetchTopStoriesData', url);
  return makeRequest.get(url);
}

function fetchSearchRedirectionData(params) {
  const domain = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;
  const searchKeyword =
    typeof params.searchKeyword === 'string'
      ? params.searchKeyword.replace(/-/g, ' ')
      : params.searchKeyword;
  const url = `${domain}/search_redirection_mapping_info.cms?keywords=${searchKeyword}&feedtype=json`;
  // #todo remove while pushing
  // console.log('fetchSearchRedirectionData url', url);
  return makeRequest.get(url, { isMobile: params.isWapView });
}

function fetchPubOrderData() {
  const url = `https://timesofindia.indiatimes.com/toipublisherfeed.cms?feedtype=sjson`;
  return makeRequest.get(url);
}

function fetchSeoKeywords(params) {
  const domain = __PROD__ ? TOI_LIVE_DOMAIN : TOI_DEV_DOMAIN;
  const url = `${domain}/feeds/topic_data_include.cms?q=${
    params.searchKeyword
  }${params.page ? `&pagetype=${params.page}` : ``}&feedtype=sjson`;
  return makeRequest.get(url);
}

function fetchTopicData({ params, frmEtimes, topicData }) {
  let pageCount;
  if (params.isWapView) {
    pageCount =
      (ContentLoadCount.mweb && ContentLoadCount.mweb[params.page]) || 32;
    if (!params.page)
      pageCount = ContentLoadCount.mweb && ContentLoadCount.mweb.all;
  } else {
    pageCount =
      (ContentLoadCount.web && ContentLoadCount.web[params.page]) || 32;
    if (!params.page)
      pageCount = ContentLoadCount.web && ContentLoadCount.web.all;
  }
  const domain = frmEtimes ? 'etimes' : 'toi';
  const msid =
    topicData &&
    topicData.relatedCmsEntities &&
    Array.isArray(topicData.relatedCmsEntities) &&
    topicData.relatedCmsEntities.length > 0
      ? topicData?.relatedCmsEntities[0]?.msId
      : '';
  const url = `${getTopicFeedUrl()}/${domain}/web/show/topic?path=/topic/${
    params.page?.toLowerCase() === 'awards' ? msid : params.searchKeyword
  }${params.page ? `/${params.page}&row=${pageCount}` : `&row=${pageCount}`}${
    params.curpg && params.curpg > 1 ? `&curpg=${params.curpg}` : ``
  }`;

  return makeRequest.get(url, { isMobile: params.isWapView });
}

// Start of function to bring all tab data (including photos and videos) from  SSR only
function getTopicDataURL({
  params,
  page,
  pageCount,
  hostid,
  isAllTab = false,
  frmEtimes = false,
  topicData,
}) {
  const domain = frmEtimes ? 'etimes' : 'toi';
  const msid =
    topicData &&
    topicData.relatedCmsEntities &&
    Array.isArray(topicData.relatedCmsEntities) &&
    topicData.relatedCmsEntities.length > 0
      ? topicData?.relatedCmsEntities[0]?.msId
      : '';
  return `${getTopicFeedUrl()}/${domain}/web/show/topic?path=/topic/${
    page?.toLowerCase() === 'awards' ? msid : params.searchKeyword
  }${page ? `/${page}&row=${pageCount}` : `&row=${pageCount}`}${
    hostid ? `&hostid=${hostid}` : ``
  }${
    (page === 'news' && isAllTab && params.curpg > 1) || !isAllTab
      ? `&curpg=${params.curpg}`
      : ``
  }`;
}

function fetchAllTabTopicData(value) {
  const { params, tabsData, frmEtimes, topicData } = value;
  const updatedTabs = [...tabsData];
  const tabsUrl = [];
  let pageCount;
  if (params.isWapView) {
    pageCount = ContentLoadCount.mweb && ContentLoadCount.mweb.all;
  } else {
    pageCount = ContentLoadCount.web && ContentLoadCount.web.all;
  }
  // const urlAll = getTopicDataURL(params, 'news', pageCount, '', true);
  // const urlVideos = getTopicDataURL(params, 'videos', 4, '', true);
  // const urlPhotos = getTopicDataURL(params, 'photos', 4, '', true);
  const getPageCount = tabname => {
    if (params.isWapView) {
      return 4;
    }
    return tabname === 'filmography' || tabname === 'books' ? 6 : 5;
  };
  for (let i = 0; i < updatedTabs.length; i += 1) {
    const tabName = updatedTabs[i].name.toLowerCase();
    if (tabName === 'articles') {
      tabsUrl.push(
        getTopicDataURL({
          params,
          page: 'news',
          pageCount,
          hostid: '',
          isAllTab: true,
          frmEtimes,
          topicData,
        }),
      );
    } else if (tabName !== 'all') {
      tabsUrl.push(
        getTopicDataURL({
          params,
          page: tabName,
          pageCount: getPageCount(tabName),
          hostid: '',
          isAllTab: true,
          frmEtimes,
          topicData,
        }),
      );
    } else if (tabName === 'awards') {
      tabsUrl.push(
        getTopicDataURL({
          params,
          page: 'awards',
          pageCount: 4,
          hostid: '',
          isAllTab: true,
          frmEtimes,
          topicData,
        }),
      );
    }
  }

  // console.log(params, '========', urlAll);
  // const url = [
  //   makeRequest.get(urlAll, { isMobile: params.isWapView }),
  //   makeRequest.get(urlPhotos, { isMobile: params.isWapView }),
  //   makeRequest.get(urlVideos, { isMobile: params.isWapView }),
  // ];
  // #todo remove while pushing
  const url = [];
  for (let i = 0; i < tabsUrl.length; i += 1) {
    url.push(makeRequest.get(tabsUrl[i], { isMobile: params.isWapView }));
  }

  return url;
}
//End of function To bring all tab data (including photos and videos) from  SSR only
function fetchPhotosTopicData(value) {
  const { params, frmEtimes } = value;
  let pageCount;
  if (params.isWapView) {
    pageCount = ContentLoadCount.mweb && ContentLoadCount.mweb.photos;
  } else {
    pageCount = ContentLoadCount.web && ContentLoadCount.web.photos;
  }
  const urlPhotoStory = getTopicDataURL({
    params,
    page: 'photos',
    pageCount,
    hostid: 83,
    frmEtimes,
  });
  const urlPhotoGallery = getTopicDataURL({
    params,
    page: 'photos',
    pageCount,
    hostid: 34,
    frmEtimes,
  });
  const urlPhotoFilters = `${getTopicFeedUrl()}/toi/web/show/topic?path=/topic/${
    params.searchKeyword
  }/photos&getAboutData=true`;
  const url = [
    makeRequest.get(urlPhotoStory, { isMobile: params.isWapView }),
    makeRequest.get(urlPhotoGallery, { isMobile: params.isWapView }),
    makeRequest.get(urlPhotoFilters, { isMobile: params.isWapView }),
  ];

  return url;
}
async function fetchTabData(params, queryParam, isFilterApply) {
  let totalCount;
  const urlAll = `${
    isFilterApply ? getTopicFeedUrlReduxXHR() : getTopicFeedUrl()
  }/toi/web/show/topic?path=/topic/${
    params.searchKeyword
  }&tabCount=true&row=0${queryParam}`;
  // const urlPhoto = `${
  //   isFilterApply ? getTopicFeedUrlReduxXHR() : getTopicFeedUrl()
  // }/toi/web/show/topic?path=/topic/${
  //   params.searchKeyword
  // }/photos&tabCount=true&row=1${queryParam}`;
  const resultAll = await makeRequest.get(urlAll, {
    isMobile: params.isWapView,
  });
  // const resultPhotos = await makeRequest.get(urlPhoto);

  if (resultAll && resultAll.data && resultAll.data.contentsData) {
    const tabAllData = resultAll.data.contentsData.tabs;
    // const tabPhotoData = resultPhotos.data.contentsData.tabs;
    // const { lhsFilters } = resultAll.data.contentsData;
    const { contentsData } = resultAll.data;

    // tabData.map((data, i) => {
    //   if (i !== 1) totalCount += data.count;
    //   return data;
    // });
    totalCount = tabAllData[0].count; //  + tabPhotoData[0].count;
    // tabAllData[0].count = totalCount;
    // tabAllData[3] = tabPhotoData[3];
    return new Promise(resolve => {
      resolve({ totalCount, tabData: tabAllData, contentsData });
    });
  }
  return new Promise(resolve => {
    resolve({ totalCount: 0, tabData: {} });
  });
}

async function fetchFilterData(params) {
  const urlAll = `${getTopicFeedUrl()}/toi/web/show/topic?path=/topic/${
    params.searchKeyword
  }${params.page ? `/${params.page}` : ''}&getAboutData=true&row=0`;
  // #todo remove while pushing
  // console.log('fetchFilterData', urlAll);
  const resultAll = await makeRequest.get(urlAll, {
    isMobile: params.isWapView,
  });
  // const resultPhotos = await makeRequest.get(urlPhoto);
  if (resultAll && resultAll.data) {
    const { showPrimeFilter } = resultAll.data.contentsData || {};
    const seo = resultAll.data && resultAll.data.seo;
    if (params && params.curpg && params.curpg <= 10) {
      seo.noindexnofollow = seo.noindexnofollow || false;
    } else {
      seo.noindexnofollow = true;
    }

    const schema = resultAll.data && resultAll.data.schema;
    const topicData = resultAll.data && resultAll.data.topic;
    const trendingCelebs = resultAll.data?.contentsData?.trendingCelebs;
    const relatedCelebs = resultAll.data?.contentsData?.relatedCelebs;
    const isMoreThanOneTopic =
      resultAll.data && resultAll.data.isMoreThanOneTopic;
    const tabsData =
      resultAll.data &&
      resultAll.data.contentsData &&
      Array.isArray(resultAll.data.contentsData.tabs)
        ? resultAll.data.contentsData.tabs
        : [];
    const totalCount =
      resultAll.data &&
      resultAll.data.contentsData &&
      resultAll.data.contentsData.totalcount;
    const type = resultAll.data?.topic?.types;
    const fromEtimes = type?.indexOf('Celebrity') > -1;
    const isAuthor =
      resultAll.data &&
      resultAll.data.metaInfo &&
      resultAll.data.metaInfo.Profession &&
      resultAll.data.metaInfo.Profession === 'Author';
    return new Promise(resolve => {
      resolve({
        // lhsFilters,
        showPrimeFilter,
        isMoreThanOneTopic,
        topicData,
        seo,
        schema,
        tabsData,
        totalCount,
        trendingCelebs,
        relatedCelebs,
        fromEtimes,
        isAuthor,
      });
    });
  }
  return new Promise(resolve => {
    resolve({ lhsFilters: {}, topicData: {} });
  });
}

async function fetchKeywordsFacet(params) {
  const urlAll = `${getTopicFeedUrl()}/toi/web/show/topic?path=/topic/${
    params.searchKeyword
  }${params.page ? `/${params.page}` : ''}&keywordsfacet=true&row=0`;
  const resultAll = await makeRequest.get(urlAll, {
    isMobile: params.isWapView,
  });
  // const resultPhotos = await makeRequest.get(urlPhoto);
  if (resultAll && resultAll.data && resultAll.data.contentsData) {
    const { keywordsFacet } = resultAll.data.contentsData;
    return new Promise(resolve => {
      resolve({ keywordsFacet });
    });
  }
  return new Promise(resolve => {
    resolve({ keywordsFacet: [] });
  });
}

export function loadTopicData(value) {
  const { params } = value;
  if (!params.page) {
    return dispatch =>
      Promise.all(fetchAllTabTopicData(value))
        .then(data => {
          for (let i = 0; i < data.length; i += 1) {
            // if (data.length > 0 && data[0]) {
            //   dispatch(receiveTopicData(data[0].data, params));
            // }
            // if (data[i].data.contentsData.tn === 'video') {
            //   dispatch(receiveTopicVideoData(data[i].data, params));
            // } else if (data[i].data.contentsData.tn === 'photostory') {
            //   dispatch(receiveTopicPhotoData(data[i].data, params));
            // }
            let tabName = 'NA';
            const tnType = data[i].data?.contentsData?.tn?.toLowerCase();
            if (tnType === 'news') {
              dispatch(receiveTopicData(data[0].data, params));
            } else {
              if (tnType === 'photostory' || tnType === 'photogallery') {
                tabName = 'photo';
              } else {
                tabName = tnType;
              }
              dispatch(
                receiveTopicTabContent({
                  info: data[i].data,
                  tabName,
                }),
              );
            }
          }
          // dispatch(receiveTopicPhotoData(data[1].data, params));
          // dispatch(receiveTopicVideoData(data[2].data, params));
          // if (data.length > 0 && data[0]) {
          //   dispatch(receiveTopicData(data[0].data, params));
          // }
        })
        .catch(error => {
          dispatch(handleTopicDataError(error));
        });
  }
  if (params.page && params.page === 'photos') {
    return dispatch =>
      Promise.all(fetchPhotosTopicData(value))
        .then(data => {
          if (Array.isArray(data)) {
            dispatch(receiveTopicPhotostoryGalleryData(data, params));
            if (data[2] && data[2].data) {
              dispatch(receiveTopicData(data[2].data, params));
              // if (data[2].data.topic) {
              //   dispatch(receiveTopicAboutData(data[2].data, params));
              // }
            }
          }
        })
        .catch(error => dispatch(handleTopicDataError(error)));
  }
  return dispatch =>
    fetchTopicData(value)
      .then(data => {
        if (data.data && data.data.contentsData) {
          if (params.page === 'photos')
            dispatch(receiveTopicPhotoData(data.data, params));
          if (params.page === 'videos')
            dispatch(receiveTopicVideoData(data.data, params));
          if (params.page === 'news')
            dispatch(receiveTopicNewsData(data.data, params));
          else
            dispatch(
              receiveTopicTabContent({
                info: data.data,
                tabName: params.page,
              }),
            );
          // else dispatch(receiveTopicData(data.data, params));
        }
        // if (data.data && data.data.topic)
        //   dispatch(receiveTopicAboutData(data.data, params));
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}
export function loadTopicTabData(
  params,
  queryParam = '',
  isFilterApply = false,
) {
  return dispatch =>
    fetchTabData(params, queryParam, isFilterApply)
      .then(data => {
        if (data.totalCount >= 0 && data.tabData) {
          dispatch(receiveTopicTabData(data));
        }
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}

export function loadSeoKeywords(params) {
  return dispatch =>
    fetchSeoKeywords(params)
      .then(data => {
        if (data && data.data) {
          dispatch(receiveSeoKeywords(data.data));
        }
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}
export function loadPubOrderList() {
  return dispatch =>
    fetchPubOrderData()
      .then(data => {
        if (data && data.data) dispatch(receivePubListData(data.data));
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}

export function loadTopicFilterData(params) {
  return dispatch =>
    new Promise(res => {
      fetchFilterData(params)
        .then(data => {
          dispatch(receiveTopicFilterData(data));
          res({
            tabsData: data.tabsData,
            fromEtimes: data.fromEtimes,
            topicData: data.topicData,
          });
        })
        .catch(error => dispatch(handleTopicDataError(error)));
    });
}

export function loadKeywordsFacetData(params, callback) {
  return dispatch =>
    fetchKeywordsFacet(params)
      .then(data => {
        if (data.keywordsFacet) {
          dispatch(receiveKeywordsFacetData(data));
        }
        if (
          Array.isArray(data.keywordsFacet) &&
          !data.keywordsFacet.length &&
          callback &&
          typeof callback === 'function'
        ) {
          callback();
        }
      })
      .catch(error => {
        dispatch(handleTopicDataError(error));
        if (callback && typeof callback === 'function') {
          callback();
        }
      });
}

export function loadTopStoriesData() {
  return dispatch =>
    fetchTopStoriesData()
      .then(data => {
        if (data && data.data) dispatch(receiveTopStoriesData(data.data));
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}

export function loadSearchRedirectionData(params) {
  return dispatch =>
    fetchSearchRedirectionData(params)
      .then(data => {
        if (data && data.data)
          dispatch(receiveSearchRedirectionData(data.data));
      })
      .catch(error => dispatch(handleTopicDataError(error)));
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_INITIAL_TOPIC_DATA: {
      return {
        ...state,
        contentsData: action.payload.contentsData,
        // totalCount: action.payload.contentsData.actualCount,
        adData: action.payload.contentsData.ads,
      };
    }
    case RECEIVE_TOPIC_TAB_CONTENT_DATA: {
      const { info, tabName } = action.payload;

      let { schema } = state;
      if (tabName === 'filmography') {
        schema = [...state.schema, ...info.schema];
      }

      return {
        ...state,
        [tabName]: info?.contentsData?.items,
        bio: info?.contentsData?.bio,
        schema,
        // lhsFilters: action.payload.lhsFilters,
      };
    }
    // case RECEIVE_ABOUT_DATA: {
    //   return {
    //     ...state,
    //     topic: action.payload.topic,
    //   };
    // }
    case RECEIVE_TOPIC_TAB_DATA: {
      return {
        ...state,
        tabsData: action.payload.tabData,
        totalCount: action.payload.totalCount,
        // lhsFilters: action.payload.lhsFilters,
      };
    }
    case RECEIVE_TOPIC_PHOTO_DATA: {
      return {
        ...state,
        photo: action.payload.contentsData.items,
        bio: action.payload?.contentsData?.bio,
      };
    }
    case RECEIVE_TOPIC_PHOTOSTORYGALLERY_DATA: {
      let photostoryData = [];
      let photogalleryData = [];
      let bio = [];
      if (action.payload) {
        if (
          action.payload[0] &&
          action.payload[0].data &&
          action.payload[0].data.contentsData &&
          action.payload[0].data.contentsData.items &&
          Array.isArray(action.payload[0].data.contentsData.items)
        ) {
          photostoryData = action.payload[0].data.contentsData.items;
          bio = action.payload[0]?.data?.contentsData?.bio;
        }
        if (
          action.payload[1] &&
          action.payload[1].data &&
          action.payload[1].data.contentsData &&
          action.payload[1].data.contentsData.items &&
          Array.isArray(action.payload[1].data.contentsData.items)
        ) {
          photogalleryData = action.payload[1].data.contentsData.items;
        }
      }

      let pageCount = 32;
      if (action.params.isWapView) {
        pageCount = ContentLoadCount.mweb && ContentLoadCount.mweb.photos;
      } else {
        pageCount = ContentLoadCount.web && ContentLoadCount.web.photos;
      }

      let adsInsertsCount = photostoryData.filter(data => data.tn === 'ad')
        .length;
      const photostoryDataRendered = photostoryData.length - adsInsertsCount;
      let totalCount = photostoryDataRendered;
      for (let i = 0; i < photogalleryData.length; i += 1) {
        if (totalCount === pageCount) {
          break;
        }
        if (photogalleryData[i].tn && photogalleryData[i].tn !== 'ad') {
          totalCount += 1;
        } else {
          adsInsertsCount += 1;
        }
      }
      const photogalleryDataRendered = totalCount - photostoryDataRendered;

      const photo = [...photostoryData, ...photogalleryData].slice(
        0,
        totalCount + adsInsertsCount,
      );

      return {
        ...state,
        photo,
        photogalleryDataRendered,
        photostoryDataRendered,
        bio,
      };
    }
    case RECEIVE_TOPIC_VIDEO_DATA: {
      return {
        ...state,
        video: action.payload.contentsData.items,
        bio: action.payload?.contentsData?.bio,
        // totalCount: action.payload.contentsData.actualCount,
        // lhsFilters: action.payload.contentsData.lhsFilters,
      };
    }
    case RECEIVE_TOPIC_NEWS_DATA: {
      return {
        ...state,
        news: action.payload.contentsData.items,
        bio: action.payload?.contentsData?.bio,
        // totalCount: action.payload.contentsData.actualCount,
        // lhsFilters: action.payload.contentsData.lhsFilters,
      };
    }
    case RECEIVE_PUB_LIST_DATA: {
      return {
        ...state,
        pubOrderList: action.payload,
      };
    }
    case RECEIVE_SEO_KEYWORDS: {
      return {
        ...state,
        seoKeywords: action.payload,
      };
    }
    case RECEIVE_TOPIC_FILTER_DATA: {
      return {
        ...state,
        // lhsFilters: action.payload.lhsFilters || [],
        showPrimeFilter: action.payload.showPrimeFilter || false,
        topic: action.payload && action.payload.topicData,
        seo: action.payload.seo,
        schema: action.payload.schema,
        isMoreThanOneTopic: action.payload && action.payload.isMoreThanOneTopic,
        tabsData: action.payload && action.payload.tabsData,
        totalCount: action.payload && action.payload.totalCount,
        trendingCelebs: action.payload?.trendingCelebs,
        relatedCelebs: action.payload?.relatedCelebs,
        fromEtimes: action.payload?.fromEtimes,
        isAuthor: action.payload?.isAuthor,
      };
    }
    case RECEIVE_KEYWORDS_FACET_DATA: {
      return {
        ...state,
        keywordsFacet: action.payload.keywordsFacet,
      };
    }
    case RECEIVE_TOP_STORIES: {
      return {
        ...state,
        topStories: action.payload,
      };
    }
    case RECEIVE_SEARCH_REDIRECTION_DATA: {
      return {
        ...state,
        searchRedirectionUrl: action.payload && action.payload.url,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
